import { Component, OnInit,TemplateRef,ViewChild, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from '../../app.config';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-sopObserve',
  templateUrl: './sop.component.html',
  styleUrls: ['./sop.component.css']
})
export class SopObserveComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  userSubscription: Subscription;
  InstitutionsList: any = [];
  modalRef: BsModalRef;
  @ViewChild('template') template: TemplateRef<any>;
  institutionRadio;
  selectedInstitution
  selected = 0;

  mygroup = new UntypedFormGroup({
    selectedIns: new UntypedFormControl(this.selected)
  });

  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(public appConfig: AppConfig, public layoutService: PHBHPLayoutPackageService, private service: PHBHPListApiService,private modalService: BsModalService) { }

  ngOnInit() {

    if (this.appConfig.institutions) {
      this.selected = this.layoutService.institutionID;
      this.getInstitutionsbyId()
    }
    this.userSubscription = this.appConfig.userSubject.asObservable().subscribe((res) => {
      this.selected = this.layoutService.institutionID;
      this.getInstitutionsbyId()
    })
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res)=>{
      this.selected = this.layoutService.institutionID;
      this.selectedInstitution = this.InstitutionsList.find(x => x?.institution?.institutionID === this.layoutService.institutionID)?.institution?.institutionName;
    })
  }
  ngOnDestroy(){
    if(this.subscription)
      this.subscription.unsubscribe();
    if(this.userSubscription)
      this.userSubscription.unsubscribe();
  }
  getInstitutionsbyId() {
    var roleId = this.appConfig.userData.roleName.roleId
    this.service.getInstitutionsbyId(this.appConfig.institutions, roleId).subscribe((res: any) => {
      this.InstitutionsList = res;
      if(this.layoutService.institutionID)
        this.selectedInstitution = this.InstitutionsList.find(x => x?.institution?.institutionID === this.layoutService.institutionID)?.institution?.institutionName;
    });
  }
  // childData(data){

  //   switch(data.key) {
  //     case 'edit':
  //       this.router.navigate(["/sop/edit/"+data.val]);
  //     break;
  //     // case 'duplicate':
  //     // this.router.navigate(["/sop/duplicate/"+data.val]);
  //     // break;
  //   }
  // }

onInstitutionChange(id){

  this.layoutService.institutionID = id;
    this.layoutService.institutionIDSubject.next(id);

     this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === id).institution.institutionName;
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }

  openmodal(template: TemplateRef<any>){
    this.mygroup.patchValue({
      selectedIns : this.selected
    })
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' })
    )}

  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }

  isSopEditorAvailable() {
    var roleId = this.appConfig.userData.roleName.roleId;
    return roleId != 5;
  }

}
